import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import Spinner from '~/components/spinner/spinner';
import IngredientTypeText from '~/components/ingredientTypeText/ingredientTypeText';
import MeasurementTypeText from '~/components/measurementTypeText/measurementTypeText';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getIngredientsQuery = gql`
  query ingredients($breweryId: Int!) {
    ingredients(breweryId: $breweryId) {
      id
      name
      description
      isTracked
      amountOnHand
      measurementType
      type
    }
  }
`;

const IngredientsList = ({ brewery, history }) => (
  <Query query={getIngredientsQuery} variables={{ breweryId: brewery.id }} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      return (
        <Fragment>
          <URLParamBanner name="ingredient" />
          <Card className="content">
            <table className="table mb0">
              <thead>
                <tr>
                  <th className="bt-n bb-n">Name</th>
                  <th className="bt-n bb-n">Description</th>
                  <th className="bt-n bb-n">Type</th>
                  <th className="bt-n bb-n" />
                </tr>
              </thead>
              <tbody>
                {data.ingredients.map((ingredient, idx) => (
                  <tr
                    data-qa={`ingredient-${idx}`}
                    className="table-row pointer"
                    key={ingredient.id}
                    onClick={() => {
                      history.push(`/ingredients/${ingredient.id}`);
                    }}
                  >
                    <td>
                      <strong>{ingredient.name}</strong>
                    </td>
                    <td className="mw6">{ingredient.description}</td>
                    <td>
                      <IngredientTypeText capitalise type={ingredient.type} />
                    </td>
                    <td>
                      {ingredient.isTracked ? (
                        <span className={ingredient.amountOnHand < 0 && 'error'}>
                          {ingredient.amountOnHand} <MeasurementTypeText type={ingredient.measurementType} />
                        </span>
                      ) : (
                        <span className="subtext">--</span>
                      )}
                    </td>{' '}
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(IngredientsList));



// WEBPACK FOOTER //
// ./src/containers/ingredientsList/ingredientsList.jsx